/**
 * Ryan O'Dowd
 * 2024-11-16
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const Reference = (props: ReferenceProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <Text style={styles.container}>
      {props.passage.prettyPassageName()}
    </Text>
  );
};

class ReferenceProps {
  passage: any;
};

export default Reference;
